import React from "react";
import Footer from "./Footer.css";
export default function () {
  return (
    <>
      <div className="Footer-container">
        <div>
          <h3>About us</h3>
          Coffeehouse<br></br>
          Our Company<br></br>
          Our Heritage<br></br>
        </div>
        <div>
          <h3>Quick Links</h3>
          Privacy Policy<br></br>
          Delivery<br></br>
          Season's Gifting<br></br>
        </div>
        <div>
          <h3>Our Responsibility</h3>
          Community<br></br>
          Ethical Sourcing<br></br>
          Diversity<br></br>
        </div>
        <div>
          <h3>Social Media</h3>
          Facebook<br></br>
          Twitter<br></br>
          Instagram
        </div>
      </div>
         <div className="Footer-bottom">
        <div>Web Accessiblity | Privacy Statement | Terms of Use Contact Us</div>
        <div>© 2024
        Irish Coffee Company. All rights reserved.</div> 
      </div>
    </>
  );
}
